import { ref } from "vue";
import { defineStore } from "pinia";
import {
        EnumFlowType,
        IProduct
    } from "nlb-buy-go-library";

interface IInformativeCalculationStore {
    CalculationData: ICalculationData;
};

interface ICalculationData {
    calculationId: number;
    creditAmount: number | undefined;
    installmentNr: number;
    lastMonthsIncome: number | undefined;
    lastMonthsIncome2: number | undefined;
    lastMonthsIncome3: number | undefined;
    isDocumentationNeeded: boolean;
    mustProvideThreeSalaries: boolean;
    flowType: EnumFlowType | undefined;
    productList: IProduct[];
    specialProductList: IProduct[];
    selectedProduct: IProduct | undefined;
    selectedSpecialProduct: IProduct | undefined;
    selectedProductType: string | undefined;
};

const defaultCalculationData: ICalculationData = {
    calculationId: 0,
    creditAmount: 1500,
    installmentNr: 27,
    lastMonthsIncome: undefined,
    lastMonthsIncome2: undefined,
    lastMonthsIncome3: undefined,
    mustProvideThreeSalaries: false,
    isDocumentationNeeded: false,
    productList: [],
    specialProductList: [],
    flowType: EnumFlowType.POS,
    selectedProductType: undefined,
    selectedProduct: undefined,
    selectedSpecialProduct: undefined,
}

export const useInformativeCalculationStore = defineStore("informativeCaluclationStore", () => {
    const InfoState = ref<IInformativeCalculationStore>({
       
        CalculationData: {
            ...defaultCalculationData
        }
    });

    function reset() {
        InfoState.value.CalculationData = { ...defaultCalculationData }
    }
    
    return { InfoState, reset };
});
